// extracted by mini-css-extract-plugin
module.exports = {"partnershipBeginContainer":"PartnershipBegin_partnershipBeginContainer__givaa"};